import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Globe } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

export const BLOCKING_LABEL = {
  simulate_mode: "Modo simulado",
  provider_not_configured: "Falta RESEND_API_KEY en el backend",
  sender_domain_mismatch: "El remitente no pertenece al dominio de envío",
  qa_allowlist_empty: "Lista QA vacía",
  real_send_window_not_set: "Falta EMAIL_REAL_SEND_NOT_BEFORE",
};

function Row({ k, v, testId }) {
  return <div className="flex justify-between gap-4 text-sm"><span className="text-muted-foreground">{k}</span><span className="text-right break-all" data-testid={testId}>{v}</span></div>;
}

export function EmailProviderCard() {
  const [p, setP] = useState(null);
  useEffect(() => {
    api.get("/admin/email-provider").then((r) => setP(r.data.provider)).catch((e) => toast.error(formatApiError(e)));
  }, []);
  if (!p) return null;
  const ready = !p.blocking_reason;
  return (
    <Card className="border-border" data-testid="email-provider-card">
      <CardHeader>
        <CardTitle className="tracking-tight flex items-center gap-2"><Globe className="h-4 w-4" /> Proveedor de correo (global)</CardTitle>
        <CardDescription>Cuenta central de TallerOS en Resend. El dominio se administra directamente en Resend; la API key vive solo en el backend.</CardDescription>
      </CardHeader>
      <CardContent className="space-y-1 max-w-xl">
        <Row k="Estado de envío real" testId="provider-ready"
          v={<Badge variant={ready ? "default" : "secondary"}>{ready ? "Listo" : `Simulando · ${BLOCKING_LABEL[p.blocking_reason] || p.blocking_reason}`}</Badge>} />
        <Row k="Modo" v={p.mode} testId="provider-mode" />
        <Row k="API key configurada" v={p.api_key_configured ? "Sí" : "No"} testId="provider-key" />
        <Row k="Webhook configurado" v={p.webhook_configured ? "Sí" : "No"} testId="provider-webhook" />
        <Row k="Remitente" v={p.from_address} testId="provider-from" />
        <Row k="Dominio" v={`${p.sending_domain} (administrado en Resend)`} testId="provider-domain" />
        <Row k="Prefijo de asunto" v={p.subject_prefix || "—"} testId="provider-subject-prefix" />
        <Row k="Correos QA permitidos" v={p.qa_allowlist_count} testId="provider-qa-count" />
        <Row k="Envío real solo desde" v={p.real_send_not_before ? new Date(p.real_send_not_before).toLocaleString("es-MX") : "—"} testId="provider-not-before" />
      </CardContent>
    </Card>
  );
}
